import React, { useState } from 'react';
import { useLocation } from 'react-router-dom';
import { ITemporaryAnnouncementSpot } from '../../../interfaces/temporaryAnnouncements';
import {
  interactionEventPages,
  TemporaryAnnouncementEventPayload,
  trackClickTemporatyAnnouncement,
  trackCloseTemporatyAnnouncement,
  trackViewTemporatyAnnouncement
} from '../../../monitoring/interaction/dispensation-home';
import { useTemporaryAnnouncements } from '../../../queries/use-temporary-announcements';
import { TEMPORARY_ANNOUNCEMENTS_LOCAL_STORAGE_PREFIX } from '../../../services/announcements';
import TemporaryAnnouncement from '../../ui/TemporaryAnnouncement/TemporaryAnnouncement';
import { useTrackingProperties } from '../../../monitoring/utils';

const CURRENT_SPOT: ITemporaryAnnouncementSpot = 'dispensation';

const TemporaryAnnouncementsContainer: React.FC = () => {
  const [isVisible, setIsVisible] = useState<boolean>(false);
  const { pathname } = useLocation();
  const { drugstoreId, chainId, drugstoreName, chainName, drugstoreUF } = useTrackingProperties();
  const page: TemporaryAnnouncementEventPayload['page'] =
    pathname === '/'
      ? interactionEventPages.dispensador_home : interactionEventPages.dispensador_detalhes_receita

  const { data: announcement } = useTemporaryAnnouncements({
    spot: CURRENT_SPOT, onSuccess: (announcementResponse) => {
      if (announcementResponse) {
        const storageKey = `${TEMPORARY_ANNOUNCEMENTS_LOCAL_STORAGE_PREFIX}-${announcementResponse.id}-closed`;
        const isClosed = localStorage.getItem(storageKey) === 'true';
        setIsVisible(!isClosed);
        trackViewTemporatyAnnouncement({
          announcementId: announcementResponse.id,
          page,
          drugstoreId,
          chainId,
          drugstoreName,
          chainName,
          drugstoreUF,
        });
      }
    }
  })

  function openUrlInNewTab({ url }: { url?: string }): void {
    if (url) window.open(url, '_blank', 'noopener,noreferrer');
  }

  if (!announcement) return null;

  const trackEventPayload = {
    announcementId: announcement.id,
    page,
    drugstoreId,
    chainId,
    drugstoreName,
    chainName,
    drugstoreUF,
  }

  const coversSpot = announcement.spots.includes(CURRENT_SPOT);
  if (!coversSpot || !isVisible) return null;

  const handleOpenCTA = (): void => {
    openUrlInNewTab({ url: announcement?.cta?.url });
    trackClickTemporatyAnnouncement(trackEventPayload);
  };

  const handleClose = (): void => {
    const storageKey = `${TEMPORARY_ANNOUNCEMENTS_LOCAL_STORAGE_PREFIX}-${announcement.id}-closed`;
    localStorage.setItem(storageKey, 'true');
    setIsVisible(false);
    trackCloseTemporatyAnnouncement(trackEventPayload);
  };

  return (
    <TemporaryAnnouncement
      announcement={announcement}
      onClose={handleClose}
      onOpenCTA={handleOpenCTA}
    />
  );
};

export default TemporaryAnnouncementsContainer;

